import _Crossroad from "./Crossroad.vue";
import _CrossroadItemModel from "./model/CrossroadItem";
import _ICrossroadItemModel from "./model/ICrossroadItem";

export default _Crossroad;
export const Crossroad = _Crossroad;
export const CrossroadItemModel = _CrossroadItemModel;
export interface ICrossroadItemModel extends _ICrossroadItemModel {};
